import i18n from "i18n";

export const REASON_OPTIONS = i18n.t("warehouse.WriteOffs.Reason", { returnObjects: true });
